import React, { useImperativeHandle, useState, forwardRef, useEffect } from 'react'
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'

function NotReviewed(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
    })

    const [loadingReservations, setLoadingReservations] = useState(new Set())

    useImperativeHandle(ref, () => ({
        show: () => {
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()
        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleAcceptShared = async (reservationId) => {
        const reservation = props.data.find(item => item.id === reservationId)
        if (!reservation || !reservation.is_shared || !reservation.shared_reservation_id) return

        setLoadingReservations(prev => new Set([...prev, reservationId]))

        try {
            await Api.post(`shared-reservations/${reservation.shared_reservation_id}/accept`)

            // Refresh not-reviewed reservations
            if (props.onActionComplete) {
                props.onActionComplete()
            }

            // Trigger a broader refresh to update main reservations table
            if (props.onReservationUpdate) {
                props.onReservationUpdate()
            }

            // Dispatch a custom event to notify other components
            window.dispatchEvent(new CustomEvent('reservationAccepted', {
                detail: { reservationId, sharedReservationId: reservation.shared_reservation_id }
            }))

        } catch (error) {
            console.error('Error accepting shared reservation:', error)
        } finally {
            setLoadingReservations(prev => {
                const newSet = new Set(prev)
                newSet.delete(reservationId)
                return newSet
            })
        }
    }

    const handleRejectShared = async (reservationId) => {
        const reservation = props.data.find(item => item.id === reservationId)
        if (!reservation || !reservation.is_shared || !reservation.shared_reservation_id) return

        setLoadingReservations(prev => new Set([...prev, reservationId]))

        try {
            await Api.post(`shared-reservations/${reservation.shared_reservation_id}/decline`)

            if (props.onActionComplete) {
                props.onActionComplete()
            }
        } catch (error) {
            console.error('Error rejecting shared reservation:', error)
        } finally {
            setLoadingReservations(prev => {
                const newSet = new Set(prev)
                newSet.delete(reservationId)
                return newSet
            })
        }
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <div className={`${popup.modal ? 'show' : ''} popup-primary`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.extraInfo')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>
                <div className="popup-container">
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>{trans('tables.client')}</th>
                                    <th>{trans('tables.address')}</th>
                                    <th>{trans('nav.appliances')}</th>
                                    <th>{trans('tables.actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map(item => (
                                    <tr key={item.id}>
                                        <td>{item.customer ? item.customer.name + ' ' + item.customer.lastname : ''}</td>
                                        <td>{item.address}</td>
                                        <td>{item.appliances?.length ?? 1}</td>
                                        <td>
                                            <a
                                                href={item.is_shared
                                                    ? `/shared-reservations/${item.shared_reservation_id}/preview`
                                                    : `/reservations/edit/${item.id}`
                                                }
                                                className="button button-info button-small"
                                                style={{ minWidth: '60px', display: 'flex', alignItems: 'center', gap: '4px' }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={docIcon} alt="doc" style={{ width: '16px', height: '16px' }} />
                                                {trans('buttons.view')}
                                            </a>
                                            {/*NEW: Show accept/reject buttons only if the reservation is shared */}
                                            {item.is_shared ? (
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <button
                                                        className="button button-success button-small"
                                                        onClick={() => handleAcceptShared(item.id)}
                                                        disabled={loadingReservations.has(item.id)}
                                                        style={{ minWidth: '60px' }}
                                                    >
                                                        {loadingReservations.has(item.id) ? '...' : trans('buttons.accept')}
                                                    </button>
                                                    <button
                                                        className="button button-danger button-small"
                                                        onClick={() => handleRejectShared(item.id)}
                                                        disabled={loadingReservations.has(item.id)}
                                                        style={{ minWidth: '60px' }}
                                                    >
                                                        {loadingReservations.has(item.id) ? '...' : trans('buttons.reject')}
                                                    </button>
                                                </div>
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>
                                                    {/* {trans('labels.notShared')} */}
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="footer align-right">
                    <button className="button" onClick={handleHide}>
                        {trans('buttons.close')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(NotReviewed)